export const contact = {
  contactName: "Nome",
  favoriteContact: "Favoritos",
  contactAction: "Ação",
  contactEmail: "E-mail",
  contactTransfer: "Transferência",
  contactDelete: "Excluir ",
  contactDeleteMessage: "Tem certeza que quer excluir este contato?",
  contactEdit: "Editar",
  contactEditMessage: "Tem certeza que quer alterar este contato da sua lista de favoritos?",
  contactConfirmYes: "Sim",
  contactConfirmNo: "Não",
  contactDeleteSuccess: "Contato excluído com sucesso!",
  contactAddSuccess: "Contato adicionado com sucesso!",
  contactBackBtn: "Voltar",
  contactsBtnAdd: "Adicionar",
  contactModalAdd: "Adicionar contato",
  contactSearch: "Buscar contato",
  contactsTableUpdating: "Atualizando contatos...",
  contactLoading: "Carregando informações do contato...",
  contactError: "Erro ao obter as informações do contato. O contato não existe.",
  contactNotFound: "Contato não encontrado.",
  contactAlreadyInList: "O contato já está na lista.",
  contactAddBtn: "Adicionar",
  contactCancelBtn: "Cancelar",
  contactBackBtnText: "Voltar",
  contactSearchRequired: "Informe um e-mail ou apelido",
  contactSearchMinLength: "Mínimo de 3 caracteres",
  contactSearchPlaceholder: "E-mail ou apelido",
};
